<template>
    <page :showBackButton="true">
        <template v-if="!my21Joined && my21StartDate === null">
            <ion-slides
                class="c-my21-slider"
                :pager="true"
                :options="slideOpts"
                ref="slider"
            >
                <ion-slide class="c-my21-slider__slide">
                    <img
                        :src="`${baseurl}/content/dam/klickmal/me1ns/my21/balloon_21.png`"
                    />
                    <b>
                        Stärke dein Immunsystem in nur 21 Tagen
                    </b>
                    <p>
                        Starte jeden Tag mit einem Video des renommierten
                        Mediziners Univ. Prof. Dr. Lalouschek. Mit dem 21 Tage
                        Programm zu einem verbesserten Wohlbefinden und einer
                        gesteigerten Widerstandsfähigkeit.
                    </p>
                </ion-slide>
                <ion-slide class="c-my21-slider__slide">
                    <img
                        :src="`${baseurl}/content/dam/klickmal/me1ns/my21/lalouschek.png`"
                    />
                    <b>
                        Wer steckt dahinter?
                    </b>
                    <p>
                        Univ. Prof. Dr. Wolfgang Lalouschek ist Neurologe und
                        systemischer Coach in Wien. Gemeinsam mit seinem Team
                        hat er das 21-Tage-Programm, basierend auf aktuellen
                        Forschungsergebnissen, entwickelt.
                    </p>
                </ion-slide>
                <ion-slide class="c-my21-slider__slide">
                    <img
                        :src="`${baseurl}/content/dam/klickmal/me1ns/my21/cards.png`"
                    />
                    <b>
                        So funktioniert's
                    </b>
                    <p>
                        Wir schalten dir jeden Tag eine neue Übung aus dem
                        21-Tage-Programm frei. Sobald neue Inhalte für dich
                        verfügbar sind, bekommst du eine Push-Meldung. Am Ende
                        jedes Tages kannst du deine Notizen und Erfahrungen
                        festhalten.
                    </p>
                </ion-slide>
            </ion-slides>
            <ion-button
                @click="my21Joined = true"
                expand="block"
                class="ion-margin-top"
            >
                <ion-label>Jetzt mitmachen</ion-label>
            </ion-button>
        </template>
        <template v-else>
            <ion-row class="ion-margin-bottom">
                <ion-col size="3">
                    <img
                        width="70"
                        :src="`${baseurl}/content/dam/klickmal/me1ns/my21/balloon_21_solo.png`"
                    />
                </ion-col>
                <ion-col>
                    <h1 style="margin-top: 0;">MY 21</h1>
                    Stärke dein Immunsystem in 21 Tagen
                </ion-col>
            </ion-row>
            <div v-if="my21StartDate === null">
                <p>
                    <b>{{ welcomeText }}</b>
                </p>
                <p>
                    wir schalten in den kommenden drei Wochen jeden Tag eine
                    neue Übung aus dem 21-Tage-Programm für dich frei. Aktiviere
                    Push Nachrichten für die Wüstenrot klickmal App dann
                    informieren wir dich, sobald neue Inhalte verfügbar sind.
                    Halte deine Erfahrungen am besten täglich fest. Deine
                    Notizen findest du auch nach dem Programm in deiner DokBox
                    zum Nachlesen.
                </p>
                <ion-button
                    expand="block"
                    @click="startMy21"
                    class="u-m-top-xxlarge"
                    >Jetzt starten</ion-button
                >
            </div>
            <template v-else>
                <ion-row class="my21-grid">
                    <ion-col
                        size-lg="2"
                        size-md="2"
                        size-sm="3"
                        size="4"
                        :key="key"
                        v-for="(value, key) in $store.state.my21.all"
                    >
                        <ion-card
                            :button="getStatus(key) !== '-future'"
                            class="ion-text-center c-my21-link"
                            :class="['-' + value.category, getStatus(key), ,]"
                            @click="goToDay(key)"
                        >
                            <div
                                class="c-my21-link__topcontainer"
                                :class="{ '-done': daysDone[key] }"
                            >
                                <div
                                    class="c-my21-link__count"
                                    v-html="key"
                                ></div>
                                <div class="c-my21-link__imagecontainer">
                                    <img
                                        class="c-my21-link__image"
                                        :src="`${baseurl}/content/dam/klickmal/me1ns/my21/${value.image}`"
                                    />
                                </div>
                                <!-- <ion-icon :name="icon"></ion-icon> -->
                                <!-- <span :class="icon"></span> -->
                            </div>
                            <div
                                class="c-my21-link__text"
                                v-html="value.title_short"
                            ></div>
                        </ion-card>
                    </ion-col>
                </ion-row>
                <!-- <ion-button
                    expand="block"
                    @click="reset()"
                    class="ion-margin-top"
                    >Zurücksetzen</ion-button
                > -->
            </template>
        </template>
    </page>
</template>

<script>
import Page from "@/components/Page";
// import { getMy21Content } from "@/api/my21";

import { BASEURL } from "@/utils/globals";
import { Plugins, Capacitor } from "@capacitor/core";

const { LocalNotifications, Storage } = Plugins;
const SECONDS = 60 * 60 * 24;

let daysDone = {};
for (let i = 1; i <= 21; i++) {
    daysDone[i] = false;
}

export default {
    components: { Page },
    props: {},
    data() {
        return {
            baseurl: BASEURL,
            Browser: Plugins.Browser,
            my21List: "",
            my21Joined: false,
            slideOpts: {
                initialSlide: 1,
                speed: 400,
                autoplay: {
                    delay: 15000,
                },
            },
            my21StartDate: null,
            today: new Date(),
            dayDifference: 0,
            storage: Storage,
            daysDone: daysDone,
        };
    },
    mounted() {
        this.$store.dispatch("my21/getMy21Content").then(() => {
            for (let my21Key in this.$store.state.my21.all) {
                Storage.get({
                    key: "my21-day" + my21Key + "-done",
                }).then(({ value: value }) => {
                    if (value === "true") {
                        this.$set(this.daysDone, my21Key, true);
                    }
                });
            }
        });
        Storage.get({ key: "my21startdate" }).then(({ value: value }) => {
            // adventkalender variante 1 (ohne Onboarding)
            // if (value === null && this.isDateInDecember2020(this.today)) {
            //     value = new Date(this.today.toISOString());
            //     value.setDate(1);
            //     value = value.toISOString();
            //     Storage.set({
            //         key: "my21startdate",
            //         value: value,
            //     });
            // }

            if (value !== null) {
                // adventkalender variante 2 (mit Onboarding) - Kunde hat im Dezember 2020 gestartet
                const date = new Date(value);
                if (this.isDateInDecember2020(date)) {
                    date.setDate(1);
                    value = date.toISOString();
                    Storage.set({
                        key: "my21startdate",
                        value: value,
                    });
                }
                this.setStartDate(value);
            }
        });
    },
    computed: {
        welcomeText() {
            let result = "";
            if (this.$store.state.user.details.vorname) {
                result =
                    "Hallo " + this.$store.state.user.details.vorname + ",";
            } else {
                result = "Hallo,";
            }
            return result;
        },
    },
    methods: {
        reset() {
            this.storage.remove({ key: "my21startdate" });
            window.location.reload();
        },
        goToDay(day) {
            if (day <= this.dayDifference + 1) {
                this.$router.push({
                    name: "my21-day",
                    params: {
                        day: day,
                    },
                });
            }
        },
        getStatus(key) {
            if (key < this.dayDifference + 1) {
                return "-past";
            } else if (key == this.dayDifference + 1) {
                return "-current";
            } else {
                return "-future";
            }
        },
        setStartDate(value) {
            this.my21StartDate = new Date(value);
            const timeDifference = this.today - this.my21StartDate;
            this.dayDifference = Math.floor(
                timeDifference / (1000 * 60 * 60 * 24)
            );
        },
        isDateInDecember2020(date) {
            let result = false;
            if (date.getMonth() === 11 && date.getFullYear() === 2020) {
                result = true;
            }
            return result;
        },
        async startMy21() {
            const date = new Date(this.today.toISOString());
            let startDay = 1;
            // adventkalender variante 2 (mit Onboarding) - Kunde hat noch nicht gestartet
            if (this.isDateInDecember2020(date)) {
                startDay = date.getDate();
                date.setDate(1);
            }
            const dateIsoString = date.toISOString();
            this.setStartDate(dateIsoString);
            Storage.set({
                key: "my21startdate",
                value: dateIsoString,
            });
            // if (permission.granted) {
            // LocalNotifications.addListener("localNotificationReceived", () => {
            // console.log(notification);
            // });
            // LocalNotifications.addListener(
            //     "localNotificationActionPerformed",
            //     () => {
            // console.log(notification);
            //     }
            // );
            if (Capacitor.isNative) {
                await LocalNotifications.requestPermission();
                for (let my21key in this.$store.state.my21.all) {
                    let day = parseInt(my21key);
                    // if(day > 2){
                    //     break;
                    // }
                    if (day > startDay) {
                        let my21entry = this.$store.state.my21.all[my21key];
                        const titleShort = my21entry.title_short.replace(
                            "&shy;",
                            ""
                        );
                        LocalNotifications.schedule({
                            notifications: [
                                {
                                    title: "MY 21",
                                    body:
                                        "Tag " +
                                        day +
                                        ": Heute geht´s um das Thema „" +
                                        titleShort +
                                        "”.",
                                    id: day,
                                    schedule: {
                                        at: new Date(
                                            Date.now() +
                                                1000 *
                                                    SECONDS *
                                                    (day - startDay)
                                        ),
                                    },
                                    sound: null,
                                    attachments: null,
                                    actionTypeId: "",
                                    extra: null,
                                },
                            ],
                        });
                    }
                    // console.log("scheduled notifications", notifs);
                    // }
                }
            }

            let daySuffix = "";
            if (startDay > 1) {
                daySuffix = " bis Tag " + startDay;
            }
            this.$ionic.alertController
                .create({
                    header: this.welcomeText,
                    message:
                        "cool, dass du mitmachst! Du kannst gleich durchstarten - die Übungen für Tag 1" +
                        daySuffix +
                        " stehen schon für dich bereit. Viel Spaß!",
                    buttons: ["Weiter"],
                })
                .then((a) => {
                    // a.onDidDismiss().then(() => {
                    //   this.$store.commit("setError", false);
                    // });
                    a.present();
                });
        },
    },
};
</script>

<style scoped lang="scss">
.my21-grid {
    @media only screen and (min-width: $breakpoint-sm) {
        --ion-grid-column-padding: 10px;
        --ion-grid-column-padding-xs: 10px;
        --ion-grid-column-padding-sm: 10px;
        --ion-grid-column-padding-md: 10px;
        --ion-grid-column-padding-lg: 10px;
        --ion-grid-column-padding-xl: 10px;
    }
}
.c-my21-link {
    padding: var(--gangl-padding-small) var(--gangl-padding-small);
    margin: 0;
    height: 100%;
    position: relative;
    overflow: initial;

    @media only screen and (min-width: $breakpoint-sm) {
        font-size: large;
    }

    &__count {
        font-size: xx-large;
        display: inline-block;
    }
    &__image {
        width: 50px;
        @media only screen and (min-width: $breakpoint-sm) {
            width: 70px;
        }
    }
    &__text {
        line-height: 1.25;
    }
    &__topcontainer {
        display: flex;
        align-items: center;
        margin-bottom: var(--gangl-padding-small);
    }
    &__imagecontainer {
        display: inline-block;
        flex-grow: 1;
        // text-align: center;
        img {
            // margin: 0 auto;
            float: right;
            padding: var(--gangl-padding-small);
            border-radius: 500px;
        }
    }

    // [class^="icon-"],
    // [class*=" icon-"] {
    //     font-size: xx-large;
    // }
    &.-current {
        background-color: #ec9797;
    }
    &.-past {
        background-color: var(--gangl-color-gesundheit);
    }
    .-done {
        &:before {
            content: "✔";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            transform: translate(-40%, -40%);
            background-color: var(--gangl-color-gesundheit);
            box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);

            padding: 5px;
            width: 15px;
            height: 15px;
            line-height: 15px;
            border-radius: 100px;
        }
    }

    &.-future {
        opacity: 0.5;
    }

    &.-sport img {
        // background-color: #dfe3cc;

        background-color: #f5e7b8;
    }
    &.-mental img {
        background-color: #f5e7b8;
    }
    &.-ernaehrung img {
        background-color: #f5e7b8;
    }
    &.-gesundheit img {
        background-color: #f5e7b8;
    }
}
.c-my21-slider {
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    border-radius: 20px;
    min-height: 60vh;
    background-color: white;

    @media only screen and (min-width: $breakpoint-sm) {
        min-height: 70vh;
    }
    &__slide {
        flex-direction: column;
        padding: 20px 20px;
        background-color: white;
        color: black;
    }
}
</style>
